module.exports = __webpack_public_path__ + "static/media/general-surgery-top.ec70e4d6.svg";